export default function PromptCrateSupport() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Support - PromptCrate
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            Help, troubleshooting, and contact details for PromptCrate.
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <h2 className="text-2xl font-bold text-[#A8720E]">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I save a prompt?
              </h3>
              <p className="mt-1">
                Tap Create, give your prompt a title, paste the prompt text,
                pick a category, and save. Your prompt is stored on your device
                and ready to reuse anytime — no account required.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do fill-in variables work?
              </h3>
              <p className="mt-1">
                Wrap any changing part of a prompt in double braces, like{" "}
                <code>{"{{topic}}"}</code> or <code>{"{{tone}}"}</code>.
                PromptCrate turns each placeholder into a simple input field. Tap
                Fill, type your values, and the finished prompt is assembled for
                you — then copy it with one tap.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Is there a ready-made prompt library?
              </h3>
              <p className="mt-1">
                Yes. PromptCrate ships with a curated starter collection of
                prompt templates across categories such as Writing, Coding,
                Marketing, Business, Education, Creative, Productivity, Research,
                Image Gen and SEO. Tap any one to favorite it and make it your
                own.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                What are Favorites and My Prompts?
              </h3>
              <p className="mt-1">
                Bookmark the prompts you reach for most to find them under
                Favorites, and keep your own custom prompts in the My Prompts
                tab. Everything stays in sync and stored locally on your device.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Does the app work offline?
              </h3>
              <p className="mt-1">
                Yes. Saving, organizing, filling and copying prompts works
                offline. Internet access is only required for services such as
                ads, analytics, or store links.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                What does the Pro upgrade include?
              </h3>
              <p className="mt-1">
                PromptCrate is free to use. A single one-time Pro upgrade unlocks
                premium prompt packs and unlimited saved prompts, and removes
                ads. There is no subscription and no recurring charge.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Why am I seeing ads?
              </h3>
              <p className="mt-1">
                Some versions of the app show ads to support ongoing
                development, maintenance, and feature updates. The one-time Pro
                upgrade removes them.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                The app is crashing — what should I do?
              </h3>
              <p className="mt-1">
                Make sure you are on the latest version from Google Play, then
                fully close and reopen the app. If the problem continues, email
                us the details below and we will help.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-[#A8720E]">Contact Support</h2>
          <p>
            If you need help, have feedback, or want to report an issue, email{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>
            . We typically respond within 24-48 hours.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Report a Bug</h2>
          <p>
            To help us resolve issues faster, include the following in your
            message when possible:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Your device model and OS version</li>
            <li>The app version shown in Settings</li>
            <li>A short description of the issue</li>
            <li>Steps to reproduce the problem</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">App Information</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>App Name:</strong> PromptCrate
            </li>
            <li>
              <strong>Developer:</strong> Cosmovex
            </li>
            <li>
              <strong>Contact Email:</strong>{" "}
              <a
                href="mailto:trionapps@gmail.com"
                className="text-[#0F6BBF] underline"
              >
                trionapps@gmail.com
              </a>
            </li>
            <li>
              <strong>Privacy Policy:</strong>{" "}
              <a
                href="https://cosmovexapps.com/apps/promptcrate/privacy-policy"
                className="text-[#0F6BBF] underline"
              >
                https://cosmovexapps.com/apps/promptcrate/privacy-policy
              </a>
            </li>
            <li>
              <strong>Support URL:</strong>{" "}
              <a
                href="https://cosmovexapps.com/apps/promptcrate/support"
                className="text-[#0F6BBF] underline"
              >
                https://cosmovexapps.com/apps/promptcrate/support
              </a>
            </li>
          </ul>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-center text-sm text-[#8A93A2]">
          © {new Date().getFullYear()} Cosmovex - All rights reserved.
        </footer>
      </section>
    </main>
  );
}
